import { render, staticRenderFns } from "./doclistedit.vue?vue&type=template&id=ea3cf580"
import script from "./doclistedit.vue?vue&type=script&lang=js"
export * from "./doclistedit.vue?vue&type=script&lang=js"
import style0 from "./doclistedit.vue?vue&type=style&index=0&id=ea3cf580&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports